import { render, staticRenderFns } from "./PreviewPopUp.vue?vue&type=template&id=720d4b03&scoped=true"
import script from "./PreviewPopUp.vue?vue&type=script&lang=js"
export * from "./PreviewPopUp.vue?vue&type=script&lang=js"
import style0 from "./PreviewPopUp.vue?vue&type=style&index=0&id=720d4b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d4b03",
  null
  
)

export default component.exports